import { useState } from "react";
import ScoreTable from "./ScoreTable";
import { useSelector } from "react-redux";

const GameTable = () => {
  const { matches: cricketMatches } = useSelector((state) => state.matches.cricket);
  const { matches: soccerMatches } = useSelector((state) => state.matches.soccer);
  const { matches: tennisMatches } = useSelector((state) => state.matches.tennis);

  const [activeTab, setActiveTab] = useState("CRICKET");
  const [loading, setLoading] = useState(false);

  const tabData = {
    CRICKET: cricketMatches,
    FOOTBALL: soccerMatches,
    TENNIS: tennisMatches,
    "HORSE RACING": [],
    "GREYHOUND RACING": [],
  };

  const sports = [
    { name: "CRICKET", icon: "./sports/4.png", h: 20, w: 20 },
    { name: "FOOTBALL", icon: "./sports/1.png", h: 20, w: 20 },
    { name: "TENNIS", icon: "./sports/2.png", h: 20, w: 20 },
    { name: "HORSE RACING", icon: "./sports/7.png", h: 27, w: 27 },
    { name: "GREYHOUND RACING", icon: "./sports/4339.png", h: 25, w: 25 },
  ];

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 50); // slight delay for smooth UI transition
  };

  return (
    <>
      {/* Tabs */}
      <div className="flex soprts-nav overflow-x-auto whitespace-nowrap bg-[#223b52]">
        {sports.map((cat, index) => (
          <div
            key={index}
            onClick={() => handleTabClick(cat.name)}
            className={`cursor-pointer flex sports-box flex-col items-center justify-center gap-[2px] h-[50px] text-center text-white px-2 ${
              activeTab === cat.name ? "bg-[#0088cc]" : ""
            }`}
          >
            <div className="mb-1">
              <img src={cat.icon} alt={cat.name} height={cat.h} width={cat.w} />
            </div>
            <span className="text-[12px] font-semibold">{cat.name}</span>
          </div>
        ))}
      </div>

      {/* Match Table */}
      <div className="ct !p-[5px] md:!pr-[0px]">
        {/* <div className="border-t border-gray-300 border-b overflow-hidden !px-2 bg-[#F7F7F7] !mt-1">
          <table className="w-full text-center">
            <thead>
              <tr className="h-7">
                <th className="text-xs md:w-[66%] font-bold text-left text-black">Game</th>
                <th className="text-xs font-bold text-black">1</th>
                <th className="text-xs font-bold text-black">X</th>
                <th className="text-xs font-bold text-black">2</th>
              </tr>
            </thead>
          </table>
        </div> */}
        

        {/* Loading or ScoreTable */}
        {loading ? (
          <div className="text-center py-4 text-sm text-gray-600">Loading...</div>
        ) : (
          <ScoreTable Matches={tabData[activeTab]} />
        )}
      </div>
    </>
  );
};

export default GameTable;
